import { module } from 'modujs'

export default class extends module {
    constructor(m) {
        super(m)

        // Binding
        this.onResizeBind = this.onResize.bind(this)
        this.onFontsLoadedBind = this.onFontsLoaded.bind(this)
        this.onClickBind = this.onClick.bind(this)

        // UI
        this.$el = this.el
        this.$buttons = this.$('button');
        this.$tilesContent = this.$('partnerContent');

        // Data
        this.data = this.getData('data')
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        if (!this.data) return
        
        this.data = JSON.parse(this.data)

        this.bindEvents()

        if (window.isFontsLoaded) {
            this.onFontsLoaded()
        }
    }

    destroy() {
        super.destroy()
        this.unbindEvents()
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        window.addEventListener("resizeEnd", this.onResizeBind)
        window.addEventListener("fontsLoaded", this.onFontsLoadedBind)

        for (let index = 0; index < this.$buttons.length; index++) {
            const $button = this.$buttons[index];
            $button.addEventListener("click", this.onClickBind)
        }
    }

    unbindEvents() {
        window.removeEventListener("resizeEnd", this.onResizeBind)
        window.removeEventListener("fontsLoaded", this.onFontsLoadedBind)

        for (let index = 0; index < this.$buttons.length; index++) {
            const $button = this.$buttons[index];
            $button.removeEventListener("click", this.onClickBind)
        }
    }

    ///////////////
    // Callbacks
    ///////////////
    onResize() {
        this.equalContent()
    }

    onFontsLoaded() {
        this.equalContent()
        this.call('update', null, 'Scroll')
    }

    onClick(e) {
        const $buttons = [...this.$buttons]
        const index = $buttons.indexOf(e.target)
        this.call('open', this.data[index], 'ModalPartner')
    }
    
    ///////////////
    // Methods
    ///////////////
    equalContent() {
        const heights = []

        let index = 0
        while(index < this.$tilesContent.length) {
            const $tileContent = this.$tilesContent[index]
            const $title = this.$('partnerTitle', $tileContent)
            $title[0] && heights.push($title[0].offsetHeight)
            index++
        }

        this.$el.style.setProperty('--content-height', `${Math.max(...heights)}px`);
    }
}